import { gql } from '@apollo/client';
import { PARAMETER_FIELDS, EMBEBED_TREE_MAP_FIELDS } from '@isyc-react/oc-api';
export const NEWO_DOSSIER_READ = gql`
  ${PARAMETER_FIELDS}
  ${EMBEBED_TREE_MAP_FIELDS}
  fragment NewoDossierRead on DossierDto {
    id
    businessUnitId
    creationTimestamp
    createdBy
    parameters {
      ...ParameterFields
    }
    treeWorkFlowMap {
      ...EmbebedTreeMapFields
    }
  }
`;